import { useState } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import styles from './forgotten.module.css';
import { Card, CardContent } from 'shared-components';
import { Button } from 'shared-components';
import { FormGroup } from 'shared-components';
import { Link } from 'react-router-dom';
import { useForgottenLoginMutation } from './forgotten.api';
import { FormLayout } from 'shared-components';
import { Label } from 'shared-components';
import { Input } from 'shared-components';
import { EnvelopeIcon } from '@heroicons/react/24/outline';
import classNames from 'classnames';
import { Logo } from 'shared-components';

export const Forgotten = () => {
  const [forgottenLogin] = useForgottenLoginMutation();
  const [error, setError] = useState<boolean>(false);
  const [done, setDone] = useState<boolean>(false);

  const { handleSubmit, getFieldProps, isSubmitting } = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: yup.object({
      email: yup.string().email('Invalid email').required('Required'),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      setError(false);
      const result = await forgottenLogin(values);
      if ('error' in result) {
        console.error(result.error);
        setError(true);
        return;
      } else if ('data' in result) {
        setDone(true);
      }
      setSubmitting(false);
    },
  });
  return (
    <div className={styles.container}>
      <Logo />
      <Card className={styles.card}>
        <CardContent standalone={true}>
          <h2 className={styles.title}>Reset your password</h2>
          <form className={styles.form} onSubmit={handleSubmit}>
            <FormLayout>
              {error && (
                <p>
                  There was a problem with your password reset request, please
                  try again.
                </p>
              )}
              <FormGroup>
                <Label htmlFor="email">Email</Label>
                <Input
                  withIcon={<EnvelopeIcon height={22} width={22} />}
                  placeholder="Enter your email"
                  type="email"
                  bigger={true}
                  id="email"
                  {...getFieldProps('email')}
                />
              </FormGroup>

              <FormGroup>
                <Button
                  bigger={true}
                  className={classNames('w-100', styles.button)}
                  type="submit"
                  disabled={isSubmitting}
                >
                  Send password reset email
                </Button>
              </FormGroup>
              <p
                style={{
                  marginTop: '1.5rem',
                  textAlign: 'center',
                }}
              >
                Already know your password? <Link to="/">Sign in now</Link>
              </p>
              {done && (
                <p>
                  An email has been sent to the address provided with
                  instructions on how to reset your password.
                </p>
              )}
            </FormLayout>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};
